<span [class]="svgClass()" class="rtl">
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.021 3.414L1.414 12.021L0 10.607L8.607 2H1.02V0H12.02V11H10.02L10.021 3.414Z"
      fill="#545454"
    />
  </svg>
</span>
